// 暗黑
import { themeDark } from '@/assets/scss/theme/dark';
// 普通
import { themeWhite } from '@/assets/scss/theme/white';
import { usePBaseStore } from '@/store';
import { toggleAppThemeClassName } from '@vas2t-lowcode/utils';
import { isDarkSkinAsync } from '@/utils/wps-fn';

/**
 * 获取客户端当前主题
 *
 */
async function getCurrentTheme() {
  let res = {
    isDarkSkin: 0,
  };
  try {
    const isDarkSkin = await isDarkSkinAsync();
    res.isDarkSkin = isDarkSkin ? 1 : 0;
  } catch (err) {
    res = {
      isDarkSkin: 0,
    };
  }

  // 方便调试用;
  if (sessionStorage.getItem('lowcode-theme')) {
    res.isDarkSkin = 1;
  }

  const theme = res.isDarkSkin === 1 ? 'dark' : 'white';
  // 设置当前的主题
  const baseStore = usePBaseStore();
  baseStore.setTheme(theme);

  return theme;
}

/**
 * 获取主题的颜色变量
 */
async function getThemeVars() {
  const theme = await getCurrentTheme();
  // 设置主题的类名
  toggleAppThemeClassName(theme);
  return theme === 'dark' ? themeDark : themeWhite;
}

/**
 * 设置主题
 */
export async function setTheme() {
  // 主题所有变量
  const cssThemeVars = await getThemeVars();
  // 设置主题载体style
  const documentElement = document.querySelector('#lowcode-theme') as HTMLElement;
  const allVars = Object.keys(cssThemeVars).sort() as (keyof typeof cssThemeVars)[];
  // 封装CSS变量数据
  const innerText = allVars.map((cssVar) => `--lowcode-${cssVar}:${cssThemeVars[cssVar]}`).join(';');
  // 设置
  documentElement && (documentElement.innerText = `:root {${innerText}}`);
}
